import { ModalSection, Table } from '~/components/common';

import { useClaimStore } from '~/store';
import { getClaimExchangeRegisterExchangeItemsColumnDefs } from '~/utils';

import type {
  TypeExchangeRegisterSecondStepValues,
  TypeExchangeRegisterSecondStepValuesState,
} from '~/types/claim.types';

import styles from '../ClaimExchangeRegisterSecondStepContent.module.scss';

const ClaimExchangeRegisterSecondStepGoodsTable = ({
  data,
  dataState,
  onChange,
  onChangeState,
  onOpenExchangeItemAddModal,
}: {
  data: TypeExchangeRegisterSecondStepValues['exchangeOrderItems'];
  dataState: TypeExchangeRegisterSecondStepValuesState['exchangeOrderItems'];
  onChange: (values: Partial<TypeExchangeRegisterSecondStepValues>) => void;
  onChangeState: (values: Partial<TypeExchangeRegisterSecondStepValuesState>) => void;
  onOpenExchangeItemAddModal: (
    itemId: TypeExchangeRegisterSecondStepValues['exchangeOrderItems'][number]['itemId']
  ) => void;
}) => {
  const selectOptions = useClaimStore((state) => state.selectOptions.returnReason);

  const { columnDefs, gridOptions } = getClaimExchangeRegisterExchangeItemsColumnDefs({
    data,
    dataState,
    selectOptions,
    onChange,
    onChangeState,
    onOpenExchangeItemAddModal,
  });

  return (
    <ModalSection className={styles['exchange-orders']} title="교환 상품">
      <div className={styles['table-wrapper']}>
        <Table data={data} options={{ columnDefs, ...gridOptions }} />
      </div>
    </ModalSection>
  );
};

export default ClaimExchangeRegisterSecondStepGoodsTable;
